export const mixins = {
  methods: {
    linkClick(link) {
      if (link == null || "no_link" == link.type) {
        return;
      } else if ("api_note" == link.type) {
        this.$router.push({
          name: "Download",
          params: {
            type: "API_NOTE",
            id: link.tab_id,
          },
        });
      } else if ("driver" == link.type) {
        this.$router.push({
          name: "Download",
          params: {
            type: "DRIVER",
            id: link.tab_id,
          },
        });
      } else if ("programming_guide" == link.type) {
        this.$router.push({
          name: "Download",
          params: {
            type: "PROGRAMMING_GUIDE",
            id: link.tab_id,
          },
        });
      } else if ("data_sheet" == link.type) {
        this.$router.push({
          name: "Download",
          params: {
            type: "DATA_SHEET",
            id: link.tab_id,
          },
        });
      } else if ("tm_plus" == link.type) {
        this.$router.push({
          name: "TouchManagerDownload",
        });
      } else if ("investor_relation" == link.type) {
        this.$router.push({
          name: "InvestorRelation",
          params: {
            tab_id: link.tab_id,
            sub_tab_id: link.sub_tab_id,
          },
        });
      } else if ("product_type" == link.type) {
        let type = "";
        if (link.is_ic_tab) {
          type = "IC";
        } else {
          type = "MODULE";
        }
        let need_slide = 0;
        if (link.need_slide) {
          need_slide = 1;
        } else {
          need_slide = 0;
        }
        this.$router.push({
          name: "ProductType",
          params: {
            link_id: link.link_id,
            type: type,
            sub_tab_id: link.sub_tab_id,
            need_slide: need_slide,
          },
        });
      } else if ("application" == link.type) {
        this.$router.push({
          name: "Application",
          params: {
            tab_id: link.tab_id,
            sub_tab_id: link.sub_tab_id,
          },
        });
      } else if ("technology" == link.type) {
        if (link.need_slide) {
          this.$router.push({
            name: "Technology",
            params: {
              slide_id: link.slide_id,
            },
          });
        } else {
          this.$router.push({
            name: "Technology",
          });
        }
      } else if ("announcement" == link.type) {
        if (link.is_index) {
          this.$router.push({
            name: "News",
            params: {
              type: "announcement",
            },
          });
        } else {
          this.$router.push({
            name: "NewsDetail",
            query: {
              type: "announcement",
              id: link.link_id,
            },
          });
        }
      } else if ("press_release" == link.type) {
        if (link.is_index) {
          this.$router.push({
            name: "News",
            params: {
              type: "press_release",
            },
          });
        } else {
          this.$router.push({
            name: "NewsDetail",
            query: {
              type: "press_release",
              id: link.link_id,
            },
          });
        }
      } else if ("about" == link.type) {
        this.$router.push({
          name: "About",
        });
      } else if ("member_portal" == link.type) {
        this.$router.push({
          name: "MemberPortal",
        });
      } else if ("faq" == link.type) {
        if (link.is_index) {
          this.$router.push({
            name: "Faq",
          });
        } else {
          this.$router.push({
            name: "FaqDetail",
            params: {
              id: link.link_id,
            },
          });
        }
      } else if ("contact" == link.type) {
        this.$router.push({
          name: "ContactUs",
          params: {
            category: link.link_id,
          },
        });
      } else if ("support_center" == link.type) {
        let tabKey = "";
        if (link.tab_id == 0) {
          tabKey = "design_support";
        } else if (link.tab_id == 1) {
          tabKey = "quotation";
        } else if (link.tab_id == 2) {
          tabKey = "trainning";
        } else if (link.tab_id == 3) {
          tabKey = "create_project";
        } else if (link.tab_id == 4) {
          tabKey = "work_shop";
        }
        this.$router.push({
          name: "SupportCenter",
          params: {
            type: tabKey,
          },
        });
      } else if ("accessory_type" == link.type) {
        this.$router.push({
          name: "Accessory",
          params: {
            link_id: link.link_id,
            tab_id: link.tab_id,
          },
        });
      } else if ("custom_link" == link.type) {
        if (link.link) {
          window.open(link.link);
        }
      } else {
        this.$router.push({
          name: "Home",
        });
      }
    },
  },
};
